/* global globalThis */
// File bytes identify the immutable upload. No private bytes enter browser storage.
export async function prepareEvidence(values, file, crypto = globalThis.crypto) {
    if (!Number.isSafeInteger(values.expected_version) || values.expected_version < 1) throw new Error('Invalid evidence version.');
    if (!['invoice','order','receipt','agreement','external_stop','other'].includes(values.kind)) throw new Error('Invalid evidence type.');
    const source_ids = { ...(values.source_ids || {}) };
    if (Object.entries(source_ids).some(([kind,id]) => !['invoice','order_item','receipt_item'].includes(kind) || !Number.isSafeInteger(id) || id < 1)) throw new Error('Invalid evidence source.');
    if (!file && !Object.keys(source_ids).length) throw new Error('Provide a file or a source.');
    const payload = { expected_version:values.expected_version,kind:values.kind,reason:values.reason || '',source_ids };
    if (file) {
        if (!file.size || file.size > 10 * 1024 * 1024 || !['application/pdf','image/png','image/jpeg'].includes(file.type)) throw new Error('Provide a PDF, PNG or JPEG of at most 10 MiB.');
        if (!crypto?.subtle) throw new Error('Secure file fingerprint unavailable.');
        const digest = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
        payload.sha256 = Array.from(new Uint8Array(digest), byte=>byte.toString(16).padStart(2,'0')).join('');
    }
    return payload;
}
